import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ATTRIBUTES_CONSTANT } from '@sharedModule/constants/fields.constant';
import { REGEX_CONSTANT } from '@sharedModule/constants/pattern-regex.constant';
import { InputModule } from '@sharedModule/components/input/input.module';
import { showValidationMsg } from '@sharedModule/utils/form.utils';
import { AuthenticationService } from '@core/services/authentication/authentication.service';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';

@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    InputModule,
    RouterModule,
  ],
})
export class LoginComponent implements OnInit, OnDestroy {
  public attributeConstant = ATTRIBUTES_CONSTANT;
  loginForm!: FormGroup;
  onDestroy$: Subject<void> = new Subject();
  wrongPassword = false;
  constructor(
    public router: Router,
    private localStorageService: LocalStorageService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.loginForm = new FormGroup({
      [this.attributeConstant.username.key]: new FormControl('', [
        Validators.required,
        Validators.pattern(REGEX_CONSTANT.email),
      ]),
      [this.attributeConstant.password.key]: new FormControl('', [
        Validators.required,
      ]),
      termsAccepted: new FormControl(false, [Validators.requiredTrue]),
    });
  }

  onSubmit(): void {
    showValidationMsg(this.loginForm);
    if (this.loginForm.valid) {
      this.authenticationService
        .login(this.loginForm.value)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe({
          next: x => {
            if (x.success) {
              this.authenticationService.loginSignal.set(x.data);
              this.authenticationService.setCredentialVerified(true);
              this.router.navigate(['/auth/otp_verify']);
            }
          },
          error: () => (this.wrongPassword = true),
        });
    }
  }
  forgotPassword(): void {
    this.router.navigate(['auth/forgotPassword']);
  }
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.unsubscribe();
  }
}
